/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Ad_Trim_To_DurationInputs */

const en_shortcut_keys_desc_ad_trim_to_duration = /** @type {(inputs: Shortcut_Keys_Desc_Ad_Trim_To_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update the outcode of selected audio descripiton Events to match the duration of the rendered audio.`)
};

const fr_shortcut_keys_desc_ad_trim_to_duration = /** @type {(inputs: Shortcut_Keys_Desc_Ad_Trim_To_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mettre a jour l'outcode des evenements de description audio selectionnes pour correspondre a la duree de l'audio rendu.`)
};

const de_shortcut_keys_desc_ad_trim_to_duration = /** @type {(inputs: Shortcut_Keys_Desc_Ad_Trim_To_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktualisiere den Outcode der ausgewählten Audiobeschreibungsereignisse, sodass er der Dauer des gerenderten Audios entspricht.`)
};

const it_shortcut_keys_desc_ad_trim_to_duration = /** @type {(inputs: Shortcut_Keys_Desc_Ad_Trim_To_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiorna il codice di uscita degli eventi di descrizione audio selezionati in modo che corrisponda alla durata dell'audio renderizzato.`)
};

const ru_shortcut_keys_desc_ad_trim_to_duration = /** @type {(inputs: Shortcut_Keys_Desc_Ad_Trim_To_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обновите код вывода выбранных событий описания аудио, чтобы он соответствовал длительности воспроизводимого аудио.`)
};

const es_shortcut_keys_desc_ad_trim_to_duration = /** @type {(inputs: Shortcut_Keys_Desc_Ad_Trim_To_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualice el código de salida de los eventos de descripción de audio seleccionados para que coincida con la duración del audio renderizado.`)
};

const zh_cn2_shortcut_keys_desc_ad_trim_to_duration = /** @type {(inputs: Shortcut_Keys_Desc_Ad_Trim_To_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更新所选音频描述事件的输出代码，使其与渲染音频的持续时间相匹配。`)
};

const ja_shortcut_keys_desc_ad_trim_to_duration = /** @type {(inputs: Shortcut_Keys_Desc_Ad_Trim_To_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レンダリングされたオーディオの長さに合わせて、選択したオーディオ説明イベントの出力コードを更新します。`)
};

const hi_shortcut_keys_desc_ad_trim_to_duration = /** @type {(inputs: Shortcut_Keys_Desc_Ad_Trim_To_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित ऑडियो विवरण इवेंट्स के आउटकोड को रेंडर किए गए ऑडियो की अवधि से मेल खाने के लिए अपडेट करें।`)
};

const pt_pt2_shortcut_keys_desc_ad_trim_to_duration = /** @type {(inputs: Shortcut_Keys_Desc_Ad_Trim_To_DurationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualize o código de saída dos eventos de descrição de áudio selecionados para corresponder à duração do áudio renderizado.`)
};

/**
* | output |
* | --- |
* | "Update the outcode of selected audio descripiton Events to match the duration of the rendered audio." |
*
* @param {Shortcut_Keys_Desc_Ad_Trim_To_DurationInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_ad_trim_to_duration = /** @type {((inputs?: Shortcut_Keys_Desc_Ad_Trim_To_DurationInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Ad_Trim_To_DurationInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shortcut_keys_desc_ad_trim_to_duration(inputs)
	if (locale === "de") return de_shortcut_keys_desc_ad_trim_to_duration(inputs)
	if (locale === "it") return it_shortcut_keys_desc_ad_trim_to_duration(inputs)
	if (locale === "ru") return ru_shortcut_keys_desc_ad_trim_to_duration(inputs)
	if (locale === "es") return es_shortcut_keys_desc_ad_trim_to_duration(inputs)
	if (locale === "zh-CN") return zh_cn2_shortcut_keys_desc_ad_trim_to_duration(inputs)
	if (locale === "ja") return ja_shortcut_keys_desc_ad_trim_to_duration(inputs)
	if (locale === "hi") return hi_shortcut_keys_desc_ad_trim_to_duration(inputs)
	if (locale === "pt-PT") return pt_pt2_shortcut_keys_desc_ad_trim_to_duration(inputs)
	return en_shortcut_keys_desc_ad_trim_to_duration(inputs)
});